import { ChevronRightIcon } from "@heroicons/react/16/solid";
import LoadingText from "./LoadingText";
import { Tooltip } from "./Tooltip";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function StatisticsCards({
  stats,
  isSplit,
  is4ByLine,
  isMobile,
}) {
  const classColsSpan =
    stats?.length > 4 && !isSplit && !is4ByLine
      ? "sm:grid-cols-3 lg:grid-cols-3"
      : isSplit
        ? "sm:grid-cols-2"
        : is4ByLine
          ? "sm:grid-cols-3 lg:grid-cols-4"
          : "sm:grid-cols-3 lg:grid-cols-4";
  return (
    <div>
      <dl className={`grid grid-cols-1 gap-5 ${classColsSpan}`}>
        {stats.map((stat, statIdx) => (
          <div
            key={stat.name}
            className={classNames(
              classColsSpan,
              statIdx % 2 === 1
                ? "sm:border-l"
                : statIdx === 2
                  ? "lg:border-l"
                  : "",
              stat.isClickable && "hover:cursor-pointer",
              "overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 flex items-center justify-between relative right-0 top-0",
            )}
          >
            <div>
              <dt className="text-sm font-medium leading-6 text-gray-500 flex items-center">
                {stat.name}
                {stat.tooltip && !isMobile && (
                  <div className="ml-2">
                    <Tooltip
                      size="4"
                      content={<div>{stat.tooltipContent} </div>}
                    />
                  </div>
                )}
              </dt>

              <div className="flex items-center">
                <dd className="flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900 dark:text-white">
                  {stat.value === null || stat.value === undefined ? (
                    <LoadingText />
                  ) : (
                    stat.value
                  )}
                </dd>
                <dd
                  className={classNames(
                    stat.changeType === "negative"
                      ? "text-rose-600"
                      : "text-green-600",
                    "text-xs font-medium ml-3",
                  )}
                >
                  {stat.change}
                </dd>
              </div>
            </div>
            {stat.isClickable && <ChevronRightIcon className="w-5 h-5" />}
          </div>
        ))}
      </dl>
    </div>
  );
}
